import type { TextFieldToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useTextFieldTokens = (theme: Theme): TextFieldToken => {
  const { color, component, borderRadius } = theme;
  const base = {
    borderRadius: borderRadius.sm,
    textColor: color.onSurface,
    borderColor: color.outline,
    hoverBorderColor: color.onSurface,
    focusBorderColor: color.onSurface,
    disabledColor: color.disabled,
    errorColor: color.negative,
    successColor: color.positive,
    labelColor: color.onSurfaceVariant,
    requiredIndicatorColor: color.onSurfaceVariant,
  };

  return merge({}, base, component?.textField) as TextFieldToken;
};
